module.exports = __webpack_public_path__ + "img/20_71.8fc59a7f.png";